import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentView from "../../myComp/ContentView";

class VideoList extends PlusComponent {
  constructor(props) {
    super(props, "contentVideo");         
  }

  render(){     
    return (
        <div>
          <ContentView {...this.props} title="Video" controller="contentVideo"></ContentView>
        </div>
      )
    }
}

export default VideoList;